import { stepperAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const {
  definePartsStyle,
  defineMultiStyleConfig
} = createMultiStyleConfigHelpers(stepperAnatomy.keys);

const baseStyle = definePartsStyle({
  separator: {
    bg: "blackAlpha.300",
    _complete: {
      bg: "brand.500",
    },
  },
  indicator: {
    borderColor: "blackAlpha.300",
  },
});

export const Stepper = defineMultiStyleConfig({
  baseStyle,
});
